/*var app_google_integrations_table = $('#app-google-integrations-table');

if (app_google_integrations_table.length) {
    console.log("here1");
    function init_google_integrations_table() {
        console.log("here2");
        window.app_google_integrations_table
            .DataTable({
                ajax: {
                    url: '/oauth/google/list',
                    dataSrc: 'data'
                },
                columns: [
                    {data: 'email'},
                    {data: 'name'},
                    {data: 'created_at'}
                ],
                destroy: true,
                "columnDefs": [{
                    "targets": 2,
                    "createdCell": function (td, cellData, rowData, row, col) {
                        $(td).html(moment(cellData, 'YYYY-MM-DD HH:mm:ss').format('MM/DD/YY hh:mm a'));
                    }
                }]
            });
    }

    init_google_integrations_table();
}else{
    console.log("problem");
}*/

/**
 * Campaign Analytics Integration form.
 *
 * Views: campaigns/partials/form-integrations
 */

if ($('#app-campaigns-integrations-form').length) {
    show_loader();
    show_positioned_overlay_loader($('#campaigns-google-integrations-panel'));
    var campaign_analytics_data = {};
    var campaign_analytics_data_current = {};
    var campaign_analytics_data_profiles = {};
    var campaign_analytics_data_requested = [];
    var selects = {
        'account': $('#campaign_analytics_account'),
        'profile': $('#campaign_analytics_profile'),
        'property': $('#campaign_analytics_property'),
        'view': $('#campaign_analytics_view'),
    };

    var campaign_analytics_data_centro = [];
    var campaign_analytics_data_current_centro = [];
    var selects_centro = {
        'account': $('#campaign_centro_account'),
        'brand': $('#campaign_centro_brand'),
        'campaign': $('#campaign_centro_campaign'),
    };

    var campaign_analytics_button = $('#campaign_analytics_submit');
    var campaign_analytics_button_centro = $('#campaign_analytics_centro_submit');

    form_validator('#app-campaigns-integrations-form',
        {},
        {}
    );
    $.ajax({
        type: 'GET',
        url: '/analytics/views',
        dataType: 'json',
        encode: true,
        success: function (data) {
            //if(typeof data['error'] === 'undefined') {

            $.each(data, function (index, value) {
                campaign_analytics_data[index] = value;
                $.each(value['profiles'], function (index2, value2) {
                    const splittedName = index2.split('***---');
                    if (typeof campaign_analytics_data_profiles[splittedName[0]] !== 'undefined' && campaign_analytics_data_profiles[splittedName[0]] !== null && campaign_analytics_data_profiles[splittedName[0]] !== '') {
                        campaign_analytics_data_profiles[splittedName[0] + '(' + splittedName[1] + ')'] = splittedName[1];
                        campaign_analytics_data[index]['profiles'][splittedName[0] + '(' + splittedName[1] + ')'] = value2;
                    } else {
                        campaign_analytics_data_profiles[splittedName[0]] = splittedName[1];
                        campaign_analytics_data[index]['profiles'][splittedName[0]] = value2;
                    }
                    // campaign_analytics_data_profiles[splittedName[0]] = splittedName[1];
                    // campaign_analytics_data[index]['profiles'][splittedName[0]] = value2;
                    delete campaign_analytics_data[index]['profiles'][index2];
                });
            });
                // campaign_analytics_data = data;
                campaign_analytics_data_current = campaign_analytics_data;

                selects['account'].html('');
                selects['account'].append('<option value=""></option>');
                $.each(data, function (index, value) {
                    if(index !== 'error')
                        selects['account'].append('<option value="' + index + '">' + value['auth_email'] + '</option>');
                });

                if (selects['account'].data('select2')) {
                    selects['account'].data('select2').destroy();
                }
                selects['account'].select2({
                    placeholder: "Choose one to continue..."
                });

                if ($('#analytics_fill').length) {
                    campaign_analytics_fill();
                }

                selects['account'].on('select2:select', function () {
                    campaign_analytics_account_change(this);
                });
            // }else{
            //     var msg = JSON.parse(data['error']);
            //     //global_notification('warning', msg.error.message);
            // }
            hide_positioned_overlay_loader($('#campaigns-google-integrations-panel'));
            hide_loader();
        },
        error: function (xhr) {
            ajax_error();
            hide_positioned_overlay_loader($('#campaigns-google-integrations-panel'));
            hide_loader();
        }
    });

    $.ajax({
        type: 'GET',
        url: '/analytics/centro/views',
        dataType: 'json',
        encode: true,
        success: function (data) {
            console.log("centro: ", data);

            campaign_analytics_data_centro = data;
            campaign_analytics_data_current_centro = campaign_analytics_data_centro;

            selects_centro['account'].html('');
            selects_centro['account'].append('<option value=""></option>');
            $.each(data, function (index, value) {
                if(index !== 'error')
                    selects_centro['account'].append('<option value="' + index + '">' + value['name'] + '</option>');
            });

            if (selects_centro['account'].data('select2')) {
                selects_centro['account'].data('select2').destroy();
            }
            selects_centro['account'].select2({
                placeholder: "Choose one to continue..."
            });

            if ($('#analytics_fill_centro').length) {
                campaign_analytics_fill_centro();
            }

            selects_centro['account'].on('select2:select', function () {
                campaign_analytics_account_change_centro(this);
            });

            hide_loader();
        },
        error: function (xhr) {
            ajax_error();
            hide_loader();
        }
    });
}

var campaign_analytics_account_change = function (select) {
    selects['property'].html('').attr('disabled', 'disabled');
    selects['view'].html('').attr('disabled', 'disabled');
    campaign_analytics_button.attr('disabled', 'disabled');

    campaign_analytics_data_current = campaign_analytics_data[$(select).val()]['profiles'];

    selects['profile'].html('');
    selects['profile'].append('<option value=""></option>');

    $.each(campaign_analytics_data_current, function (index, value) {
        selects['profile'].append('<option value="' + index + '">' + index + '</option>');
    });

    if (selects['profile'].data('select2')) {
        selects['profile'].data('select2').destroy();
    }
    selects['profile'].select2({
        placeholder: "Choose one to continue..."
    });
    selects['profile'].attr('disabled', null);

    selects['profile'].on('select2:select', function () {
        campaign_analytics_profile_change(this);
    });
};

var campaign_analytics_account_change_centro = function (select) {
    selects_centro['campaign'].html('').attr('disabled', 'disabled');
    campaign_analytics_button_centro.attr('disabled', 'disabled');

    campaign_analytics_data_current_centro = typeof campaign_analytics_data_centro[$(select).val()] !== 'undefined' ? campaign_analytics_data_centro[$(select).val()]['brands'] : [];

    selects_centro['brand'].html('');
    selects_centro['brand'].append('<option value=""></option>');

    $.each(campaign_analytics_data_current_centro, function (index, value) {
        selects_centro['brand'].append('<option value="' + index + '">' + value['name'] + '</option>');
    });

    if (selects_centro['brand'].data('select2')) {
        selects_centro['brand'].data('select2').destroy();
    }
    selects_centro['brand'].select2({
        placeholder: "Choose one to continue..."
    });
    selects_centro['brand'].attr('disabled', null);

    selects_centro['brand'].on('select2:select', function () {
        campaign_analytics_profile_change_centro(this);
    });
};

var campaign_analytics_profile_change = function (select, toFill = false) {
    selects['view'].html('').attr('disabled', true);
    campaign_analytics_button.attr('disabled', 'disabled');

    if (campaign_analytics_data_requested.includes($(select).val())) {
        campaign_analytics_data_current = campaign_analytics_data[$(selects['account']).val()]['profiles'][$(select).val()];
        selects['property'].html('');
        selects['property'].append('<option value=""></option>');

        $.each(campaign_analytics_data_current, function (index, value) {
            if (typeof value['property'] !== 'undefined' && value['property'] !== null && value['property'] !== '') {
                selects['property'].append('<option value="' + index + '">' + value['property'] + '</option>');
            }
        });

        if (selects['property'].data('select2')) {
            selects['property'].data('select2').destroy();
        }
        selects['property'].select2({
            placeholder: "Choose one to continue..."
        });
        selects['property'].attr('disabled', null);

        selects['property'].on('select2:select', function () {
            campaign_analytics_property_change(this);
        });

        if (toFill) {
            selects['profile'].trigger('change.select2');
            selects['property'].val($('#analytics_fill_property').val());
            campaign_analytics_property_change(selects['property']);
            selects['property'].trigger('change.select2');
            selects['view'].val($('#analytics_fill_view').val());
            campaign_analytics_view_change(selects['view']);
            selects['view'].trigger('change.select2');
        }
    } else {
        show_positioned_overlay_loader($('#campaigns-google-integrations-panel-profile'));
        campaign_analytics_data_requested.push($(select).val());
        $.ajax({
            type: 'GET',
            url: '/analytics/ga4/properties/' + $(selects['account']).val() + '/' + campaign_analytics_data_profiles[$(select).val()],
            dataType: 'json',
            encode: true,
            success: function (data) {
                console.log(data);
                $.each(data, function(index, value) {
                    campaign_analytics_data[$(selects['account']).val()]['profiles'][$(select).val()].push(value);
                });
                campaign_analytics_data_current = campaign_analytics_data[$(selects['account']).val()]['profiles'][$(select).val()];
                selects['property'].html('');
                selects['property'].append('<option value=""></option>');

                $.each(campaign_analytics_data_current, function (index, value) {
                    if (typeof value['property'] !== 'undefined' && value['property'] !== null && value['property'] !== '') {
                        selects['property'].append('<option value="' + index + '">' + value['property'] + '</option>');
                    }
                });

                if (selects['property'].data('select2')) {
                    selects['property'].data('select2').destroy();
                }
                selects['property'].select2({
                    placeholder: "Choose one to continue..."
                });
                selects['property'].attr('disabled', null);

                selects['property'].on('select2:select', function () {
                    campaign_analytics_property_change(this);
                });

                if (toFill) {
                    selects['profile'].trigger('change.select2');
                    selects['property'].val($('#analytics_fill_property').val());
                    campaign_analytics_property_change(selects['property']);
                    selects['property'].trigger('change.select2');
                    selects['view'].val($('#analytics_fill_view').val());
                    campaign_analytics_view_change(selects['view']);
                    selects['view'].trigger('change.select2');
                }

                hide_positioned_overlay_loader($('#campaigns-google-integrations-panel-profile'));
            },
            error: function (xhr) {
                ajax_error();
                hide_positioned_overlay_loader($('#campaigns-google-integrations-panel-profile'));
            }
        });
    }
};

var campaign_analytics_profile_change_centro = function (select) {
    selects_centro['campaign'].html('').attr('disabled', true);
    campaign_analytics_button_centro.attr('disabled', 'disabled');

    campaign_analytics_data_current_centro = typeof campaign_analytics_data_centro[$(selects_centro['account']).val()] !== 'undefined' ? campaign_analytics_data_centro[$(selects_centro['account']).val()]['brands'][$(select).val()]['campaigns'] : [];
    selects_centro['campaign'].html('');
    selects_centro['campaign'].append('<option value=""></option>');

    $.each(campaign_analytics_data_current_centro, function (index, value) {
        selects_centro['campaign'].append('<option value="' + index + '">' + value['name'] + '</option>');
    });

    if (selects_centro['campaign'].data('select2')) {
        selects_centro['campaign'].data('select2').destroy();
    }
    selects_centro['campaign'].select2({
        placeholder: "Choose one to continue..."
    });
    selects_centro['campaign'].attr('disabled', null);

    selects_centro['campaign'].on('select2:select', function () {
        campaign_analytics_view_change_centro(this);
    });
};

var campaign_analytics_property_change = function (select) {
    campaign_analytics_button.attr('disabled', 'disabled');

    campaign_analytics_data_current = campaign_analytics_data[$(selects['account']).val()]['profiles'][$(selects['profile']).val()][$(select).val()];
    selects['view'].html('');
    selects['view'].append('<option value=""></option>');
    if (typeof campaign_analytics_data_current !== 'undefined' && campaign_analytics_data_current !== null
        && typeof campaign_analytics_data_current['views'] !== 'undefined' && campaign_analytics_data_current['views'] !== null) {
        $.each(campaign_analytics_data_current['views'], function (index, value) {
            selects['view'].append('<option data-analytics-type="' + value['type'] + '" value="' + value['id'] + '">' + value['name'] + '</option>');
        });
    }

    if (selects['view'].data('select2')) {
        selects['view'].data('select2').destroy();
    }
    selects['view'].select2({
        placeholder: "Choose one to continue..."
    });
    selects['view'].attr('disabled', null);

    selects['view'].on('select2:select', function () {
        campaign_analytics_view_change(this);
    });
};

var campaign_analytics_view_change = function (select) {
    const analytics_type = $('#campaign_analytics_view option:selected').data('analytics-type');
    if (typeof analytics_type !== 'undefined' && analytics_type !== null && analytics_type !== '') {
        $('#campaign_analytics_type').val(analytics_type);
    } else {
        $('#campaign_analytics_type').val('regular');
    }
    campaign_analytics_button.attr('disabled', null);
};

var campaign_analytics_view_change_centro = function (select) {
    campaign_analytics_button_centro.attr('disabled', null);
};

var campaign_analytics_fill = function () {
    selects['account'].val($('#analytics_fill_account').val());
    campaign_analytics_account_change(selects['account']);
    selects['account'].trigger('change.select2');
    selects['profile'].val($('#analytics_fill_profile').val());
    campaign_analytics_profile_change(selects['profile'], true);
    // selects['profile'].trigger('change.select2');
    // selects['property'].val($('#analytics_fill_property').val());
    // campaign_analytics_property_change(selects['property']);
    // selects['property'].trigger('change.select2');
    // selects['view'].val($('#analytics_fill_view').val());
    // campaign_analytics_view_change(selects['view']);
    // selects['view'].trigger('change.select2');
};

var campaign_analytics_fill_centro = function () {
    selects_centro['account'].val($('#analytics_fill_account_centro').val());
    campaign_analytics_account_change_centro(selects_centro['account']);
    selects_centro['account'].trigger('change.select2');
    selects_centro['brand'].val($('#analytics_fill_brand_centro').val());
    campaign_analytics_profile_change_centro(selects_centro['brand']);
    selects_centro['brand'].trigger('change.select2');
    selects_centro['campaign'].val($('#analytics_fill_campaign_centro').val());
    campaign_analytics_view_change_centro(selects_centro['campaign']);
    selects_centro['campaign'].trigger('change.select2');
};

/**
 * Advertiser Analytics Integration form.
 *
 * Views: advertisers/partials/form-integrations
 */

if ($('#app-advertisers-integrations-form').length) {
    show_loader();
    show_positioned_overlay_loader($('#advertisers-google-integrations-panel'));
    console.log('app-advertisers-integrations-form 320')
    var advertiser_analytics_data = {};
    var advertiser_analytics_data_current = {};
    var advertiser_analytics_data_profiles = {};
    var advertiser_analytics_data_requested = [];
    var selects = {
        'account': $('#advertiser_analytics_account'),
        'profile': $('#advertiser_analytics_profile'),
        'property': $('#advertiser_analytics_property'),
        'view': $('#advertiser_analytics_view'),
    };

    var advertiser_analytics_data_centro = [];
    var advertiser_analytics_data_current_centro = [];
    var selects_centro = {
        'account': $('#advertiser_centro_account'),
        'brand': $('#advertiser_centro_brand'),
        'campaign': $('#advertiser_centro_campaign'),
    };

    var advertiser_analytics_button = $('#advertiser_analytics_submit');
    var advertiser_analytics_button_centro = $('#advertiser_analytics_centro_submit');

    form_validator('#app-advertisers-integrations-form',
        {},
        {}
    );
    $.ajax({
        type: 'GET',
        url: '/analytics/views?advertiser=' +  adv_id,
        dataType: 'json',
        encode: true,
        success: function (data) {
            console.log('app-advertisers-integrations-form 351')
            //if(typeof data['error'] === 'undefined') {
            $.each(data, function (index, value) {
                advertiser_analytics_data[index] = value;
                $.each(value['profiles'], function (index2, value2) {
                    const splittedName = index2.split('***---');
                    advertiser_analytics_data_profiles[splittedName[0]] = splittedName[1];
                    advertiser_analytics_data[index]['profiles'][splittedName[0]] = value2;
                    delete advertiser_analytics_data[index]['profiles'][index2];
                });
            });
                // advertiser_analytics_data = data;
                advertiser_analytics_data_current = advertiser_analytics_data;

                selects['account'].html('');
                selects['account'].append('<option value=""></option>');
                $.each(data, function (index, value) {
                    if(index !== 'error')
                        selects['account'].append('<option value="' + index + '">' + value['auth_email'] + '</option>');
                });

                if (selects['account'].data('select2')) {
                    selects['account'].data('select2').destroy();
                }
                selects['account'].select2({
                    placeholder: "Choose one to continue..."
                });
            console.log('app-advertisers-integrations-form ', $('#analytics_fill').length)
                if ($('#analytics_fill').length) {
                    console.log('app-advertisers-integrations-form 371')
                    advertiser_analytics_fill();
               }

                selects['account'].on('select2:select', function () {
                    advertiser_analytics_account_change(this);
                });
            // }else{
            //     var msg = JSON.parse(data['error']);
            //     //global_notification('warning', msg.error.message);
            // }
            hide_positioned_overlay_loader($('#advertisers-google-integrations-panel'));
            hide_loader();
        },
        error: function (xhr) {
            ajax_error();
            hide_positioned_overlay_loader($('#advertisers-google-integrations-panel'));
            hide_loader();
        }
    });

    $.ajax({
        type: 'GET',
        url: '/analytics/centro/views',
        dataType: 'json',
        encode: true,
        success: function (data) {
            console.log("centro: ", data);

            advertiser_analytics_data_centro = data;
            advertiser_analytics_data_current_centro = advertiser_analytics_data_centro;

            selects_centro['account'].html('');
            selects_centro['account'].append('<option value=""></option>');
            $.each(data, function (index, value) {
                if(index !== 'error')
                    selects_centro['account'].append('<option value="' + index + '">' + value['name'] + '</option>');
            });

            if (selects_centro['account'].data('select2')) {
                selects_centro['account'].data('select2').destroy();
            }
            selects_centro['account'].select2({
                placeholder: "Choose one to continue..."
            });

            if ($('#analytics_fill_centro').length) {
                advertiser_analytics_fill_centro();
            }

            selects_centro['account'].on('select2:select', function () {
                advertiser_analytics_account_change_centro(this);
            });

            hide_loader();
        },
        error: function (xhr) {
            ajax_error();
            hide_loader();
        }
    });
}

if ($('#app-advertisers-quickbook-integrations-form').length) {
    show_loader();
    var advertiser_analytics_data = [];
    var advertiser_analytics_data_current = [];
    var selects = {
        'account': $('#advertiser_analytics_account'),
        'profile': $('#advertiser_analytics_profile'),
        'property': $('#advertiser_analytics_property'),
        'view': $('#advertiser_analytics_view'),
    };

    var advertiser_analytics_data_centro = [];
    var advertiser_analytics_data_current_centro = [];
    var selects_centro = {
        'account': $('#advertiser_centro_account'),
        'brand': $('#advertiser_centro_brand'),
        'campaign': $('#advertiser_centro_campaign'),
    };

    var advertiser_quickbooks_data_centro = [];
    var advertiser_quickbooks_data_current_centro = [];
    var selects_quickbooks = {
        'account': $('#advertiser_quickbooks_account'),
    };

    var advertiser_analytics_button = $('#advertiser_analytics_submit');
    var advertiser_analytics_button_centro = $('#advertiser_analytics_centro_submit');
    var advertiser_analytics_button_quickbook = $('#advertiser_quickbooks_submit');

    form_validator('#app-advertisers-integrations-form',
        {},
        {}
    );
    // $.ajax({
    //     type: 'GET',
    //     url: '/analytics/views',
    //     dataType: 'json',
    //     encode: true,
    //     success: function (data) {
    //         //if(typeof data['error'] === 'undefined') {
    //         advertiser_analytics_data = data;
    //         advertiser_analytics_data_current = advertiser_analytics_data;
    //
    //         selects['account'].html('');
    //         selects['account'].append('<option value=""></option>');
    //         $.each(data, function (index, value) {
    //             if(index !== 'error')
    //                 selects['account'].append('<option value="' + index + '">' + value['auth_email'] + '</option>');
    //         });
    //
    //         if (selects['account'].data('select2')) {
    //             selects['account'].data('select2').destroy();
    //         }
    //         selects['account'].select2({
    //             placeholder: "Choose one to continue..."
    //         });
    //
    //         if ($('#analytics_fill').length) {
    //             advertiser_analytics_fill();
    //         }
    //
    //         selects['account'].on('select2:select', function () {
    //             advertiser_analytics_account_change(this);
    //         });
    //         // }else{
    //         //     var msg = JSON.parse(data['error']);
    //         //     //global_notification('warning', msg.error.message);
    //         // }
    //
    //         hide_loader();
    //     },
    //     error: function (xhr) {
    //         ajax_error();
    //         hide_loader();
    //     }
    // });

    $.ajax({
        type: 'GET',
        url: '/analytics/quickbooks/views',
        dataType: 'json',
        encode: true,
        success: function (data) {
            console.log("quickbooks: ", data);
            advertiser_quickbooks_data_centro = [];
            selects_quickbooks['account'].html('');
            selects_quickbooks['account'].append('<option value=""></option>');
            for(var i in data) {
                if (i !== 'error') {
                    advertiser_quickbooks_data_centro = advertiser_quickbooks_data_centro.concat(data[i]);
                    $.each(data[i], function (index, value) {
                        if (index !== 'error' && value['Active'])
                            selects_quickbooks['account'].append('<option value="' + index + '|||' + value['DisplayName'] + '|||' + i + '">' + value['DisplayName'] + '</option>');
                    });
                }
            }
            advertiser_quickbooks_data_current_centro = advertiser_quickbooks_data_centro;
            if (selects_quickbooks['account'].data('select2')) {
                selects_quickbooks['account'].data('select2').destroy();
            }
            selects_quickbooks['account'].select2({
                placeholder: "Choose one to continue..."
            });

            if ($('#analytics_fill_quickbooks').length) {
                advertiser_analytics_fill_quickbooks();
            }

            hide_loader();
        },
        error: function (xhr) {
            ajax_error();
            hide_loader();
        }
    });

    $.ajax({
        type: 'GET',
        url: '/analytics/centro/views',
        dataType: 'json',
        encode: true,
        success: function (data) {
            console.log("centro: ", data);

            advertiser_analytics_data_centro = data;
            advertiser_analytics_data_current_centro = advertiser_analytics_data_centro;

            selects_centro['account'].html('');
            selects_centro['account'].append('<option value=""></option>');
            $.each(data, function (index, value) {
                if(index !== 'error')
                    selects_centro['account'].append('<option value="' + index + '">' + value['name'] + '</option>');
            });

            if (selects_centro['account'].data('select2')) {
                selects_centro['account'].data('select2').destroy();
            }
            selects_centro['account'].select2({
                placeholder: "Choose one to continue..."
            });

            if ($('#analytics_fill_centro').length) {
                advertiser_analytics_fill_centro();
            }

            selects_centro['account'].on('select2:select', function () {
                advertiser_analytics_account_change_centro(this);
            });

            hide_loader();
        },
        error: function (xhr) {
            ajax_error();
            hide_loader();
        }
    });
}

if ($('#app-vendors-quickbook-integrations-form').length) {
    show_loader();
    $('#vendor_quickbooks_default_item').select2({
        placeholder: "Choose one to continue..."
    });
    var vendor_quickbooks_data_centro = [];
    var vendor_quickbooks_data_current_centro = [];
    var selects_quickbooks = {
        'account': $('#vendor_quickbooks_account'),
    };
    var vendor_analytics_button_quickbook = $('#vendor_quickbooks_submit');

    form_validator('#app-vendors-quickbook-integrations-form',
        {},
        {}
    );

    $.ajax({
        type: 'GET',
        url: '/analytics/quickbooks/vendors',
        dataType: 'json',
        encode: true,
        success: function (data) {
            if(typeof data['error'] === 'undefined') {
                console.log("quickbooks: ", data);
                vendor_quickbooks_data_centro = [];
                selects_quickbooks['account'].html('');
                selects_quickbooks['account'].append('<option value=""></option>');
                for (var i in data) {
                    vendor_quickbooks_data_centro = vendor_quickbooks_data_centro.concat(data[i]);
                    $.each(data[i], function (index, value) {
                        if (index !== 'error' && value['Active'])
                            selects_quickbooks['account'].append('<option value="' + index + '|||' + value['DisplayName'] + '|||' + i + '">' + value['DisplayName'] + '</option>');
                    });
                }
                vendor_quickbooks_data_current_centro = vendor_quickbooks_data_centro;

                if (selects_quickbooks['account'].data('select2')) {
                    selects_quickbooks['account'].data('select2').destroy();
                }
                selects_quickbooks['account'].select2({
                    placeholder: "Choose one to continue..."
                });

                if ($('#analytics_fill_quickbooks').length) {
                    vendor_analytics_fill_quickbooks();
                }
            }else{
                swal({
                        title: "Warning!",
                        text: "There is an issue with you Quickbooks integration. Please add again the account in Agency Settings.",
                        type: "warning",
                        showCancelButton: false,
                        confirmButtonClass: "btn-warning",
                        confirmButtonText: "OK",
                        closeOnConfirm: true,
                        closeOnCancel: true
                    },
                    function (isConfirm) {});
            }

            hide_loader();
        },
        error: function (xhr) {
            ajax_error();
            hide_loader();
        }
    });
}

var advertiser_analytics_account_change = function (select) {
    selects['property'].html('').attr('disabled', 'disabled');
    selects['view'].html('').attr('disabled', 'disabled');
    advertiser_analytics_button.attr('disabled', 'disabled');

    advertiser_analytics_data_current = advertiser_analytics_data[$(select).val()]['profiles'];

    selects['profile'].html('');
    selects['profile'].append('<option value=""></option>');

    $.each(advertiser_analytics_data_current, function (index, value) {
        selects['profile'].append('<option value="' + index + '">' + index + '</option>');
    });

    if (selects['profile'].data('select2')) {
        selects['profile'].data('select2').destroy();
    }
    selects['profile'].select2({
        placeholder: "Choose one to continue..."
    });
    selects['profile'].attr('disabled', null);

    selects['profile'].on('select2:select', function () {
        advertiser_analytics_profile_change(this);
    });
};

var advertiser_analytics_account_change_centro = function (select) {
    selects_centro['campaign'].html('').attr('disabled', 'disabled');
    advertiser_analytics_button_centro.attr('disabled', 'disabled');

    advertiser_analytics_data_current_centro = typeof  advertiser_analytics_data_centro[$(select).val()] !== 'undefined' ? advertiser_analytics_data_centro[$(select).val()]['brands'] : [];

    selects_centro['brand'].html('');
    selects_centro['brand'].append('<option value=""></option>');

    $.each(advertiser_analytics_data_current_centro, function (index, value) {
        selects_centro['brand'].append('<option value="' + index + '">' + value['name'] + '</option>');
    });

    if (selects_centro['brand'].data('select2')) {
        selects_centro['brand'].data('select2').destroy();
    }
    selects_centro['brand'].select2({
        placeholder: "Choose one to continue..."
    });
    selects_centro['brand'].attr('disabled', null);

    selects_centro['brand'].on('select2:select', function () {
        advertiser_analytics_profile_change_centro(this);
    });
};

var advertiser_analytics_profile_change = function (select, toFill = false) {
    selects['view'].html('').attr('disabled', true);
    advertiser_analytics_button.attr('disabled', 'disabled');

    if (advertiser_analytics_data_requested.includes($(select).val())) {
        advertiser_analytics_data_current = advertiser_analytics_data[$(selects['account']).val()]['profiles'][$(select).val()];
        selects['property'].html('');
        selects['property'].append('<option value=""></option>');
        $.each(advertiser_analytics_data_current, function (index, value) {
            if (typeof value['property'] !== 'undefined' && value['property'] !== null && value['property'] !== '') {
                selects['property'].append('<option value="' + index + '">' + value['property'] + '</option>');
            }
        });

        if (selects['property'].data('select2')) {
            selects['property'].data('select2').destroy();
        }
        selects['property'].select2({
            placeholder: "Choose one to continue..."
        });
        selects['property'].attr('disabled', null);

        selects['property'].on('select2:select', function () {
            advertiser_analytics_property_change(this);
        });

        if (toFill) {
            selects['profile'].trigger('change.select2');
            selects['property'].val($('#analytics_fill_property').val());
            advertiser_analytics_property_change(selects['property']);
            selects['property'].trigger('change.select2');
            selects['view'].val($('#analytics_fill_view').val());
            advertiser_analytics_view_change(selects['view']);
            selects['view'].trigger('change.select2');
        }
    } else {
        advertiser_analytics_data_current = advertiser_analytics_data[$(selects['account']).val()]['profiles'][$(select).val()];
        selects['property'].html('');
        selects['property'].append('<option value=""></option>');

        show_positioned_overlay_loader($('#advertisers-google-integrations-panel-profile'));
        advertiser_analytics_data_requested.push($(select).val());
       console.log('profiles_profiles ', $(select).val())
       console.log('profiles_profiles url', '/analytics/ga4/properties/' + $(selects['account']).val() + '/' + advertiser_analytics_data_profiles[$(select).val()])
        $.ajax({
            type: 'GET',
            url: '/analytics/ga4/properties/' + $(selects['account']).val() + '/' + advertiser_analytics_data_profiles[$(select).val()],
            dataType: 'json',
            encode: true,
            success: function (data) {
                console.log('profiles_profiles after change', data)
                $.each(data, function(index, value) {
                    advertiser_analytics_data[$(selects['account']).val()]['profiles'][$(select).val()].push(value);
                });

                $.each(advertiser_analytics_data_current, function (index, value) {
                    if (typeof value['property'] !== 'undefined' && value['property'] !== null && value['property'] !== '') {
                        selects['property'].append('<option value="' + index + '">' + value['property'] + '</option>');
                    }
                });

                if (selects['property'].data('select2')) {
                    selects['property'].data('select2').destroy();
                }
                selects['property'].select2({
                    placeholder: "Choose one to continue..."
                });
                selects['property'].attr('disabled', null);

                selects['property'].on('select2:select', function () {
                    advertiser_analytics_property_change(this);
                });

                if (toFill) {
                    selects['profile'].trigger('change.select2');
                    selects['property'].val($('#analytics_fill_property').val());
                    advertiser_analytics_property_change(selects['property']);
                    selects['property'].trigger('change.select2');
                    selects['view'].val($('#analytics_fill_view').val());
                    advertiser_analytics_view_change(selects['view']);
                    selects['view'].trigger('change.select2');
                }

                hide_positioned_overlay_loader($('#advertisers-google-integrations-panel-profile'));
            },
            error: function (xhr) {
                ajax_error();
                hide_positioned_overlay_loader($('#advertisers-google-integrations-panel-profile'));
            }
        });
    }
};

var advertiser_analytics_profile_change_centro = function (select) {
    advertiser_analytics_button_centro.attr('disabled', 'disabled');
    advertiser_analytics_data_current_centro = typeof advertiser_analytics_data_centro[$(selects_centro['account']).val()] !== 'undefined' ? advertiser_analytics_data_centro[$(selects_centro['account']).val()]['brands'][$(select).val()]['campaigns'] : [];
    selects_centro['campaign'].html('');
    selects_centro['campaign'].append('<option value=""></option>');

    $.each(advertiser_analytics_data_current_centro, function (index, value) {
        selects_centro['campaign'].append('<option value="' + index + '">' + value['name'] + '</option>');
    });

    if (selects_centro['campaign'].data('select2')) {
        selects_centro['campaign'].data('select2').destroy();
    }
    selects_centro['campaign'].select2({
        placeholder: "Choose one to continue..."
    });
    selects_centro['campaign'].attr('disabled', null);

    selects_centro['campaign'].on('select2:select', function () {
        advertiser_analytics_view_change_centro(this);
    });
};

var advertiser_analytics_property_change = function (select) {
    advertiser_analytics_button.attr('disabled', 'disabled');

    advertiser_analytics_data_current = advertiser_analytics_data[$(selects['account']).val()]['profiles'][$(selects['profile']).val()][$(select).val()];
    selects['view'].html('');
    selects['view'].append('<option value=""></option>');

    if (typeof advertiser_analytics_data_current !== 'undefined' && advertiser_analytics_data_current !== null
        && typeof advertiser_analytics_data_current['views'] !== 'undefined' && advertiser_analytics_data_current['views'] !== null) {
        $.each(advertiser_analytics_data_current['views'], function (index, value) {
            selects['view'].append('<option data-analytics-type="' + value['type'] + '" value="' + value['id'] + '">' + value['name'] + '</option>');
        });
    }

    if (selects['view'].data('select2')) {
        selects['view'].data('select2').destroy();
    }
    selects['view'].select2({
        placeholder: "Choose one to continue..."
    });
    selects['view'].attr('disabled', null);

    selects['view'].on('select2:select', function () {
        advertiser_analytics_view_change(this);
    });
};

var advertiser_analytics_view_change = function (select) {
    const analytics_type = $('#advertiser_analytics_view option:selected').data('analytics-type');
    if (typeof analytics_type !== 'undefined' && analytics_type !== null && analytics_type !== '') {
        $('#advertiser_analytics_type').val(analytics_type);
    } else {
        $('#advertiser_analytics_type').val('regular');
    }
    advertiser_analytics_button.attr('disabled', null);
};

var advertiser_quickbooks_view_change = function (select) {
    advertiser_analytics_button_quickbook.attr('disabled', null);
};

var vendor_quickbooks_view_change = function (select) {
    vendor_analytics_button_quickbook.attr('disabled', null);
};

var advertiser_analytics_view_change_centro = function (select) {
    advertiser_analytics_button_centro.attr('disabled', null);
};

var advertiser_analytics_fill = function () {
    console.log('advertiser_analytics_fill_advertiser_analytics_fill ', selects)
    console.log('advertiser_analytics_fill_advertiser_analytics_fill analytics_fill_account', $('#analytics_fill_account').val())
    selects['account'].val($('#analytics_fill_account').val());
    advertiser_analytics_account_change(selects['account']);
    selects['account'].trigger('change.select2');
    selects['profile'].val($('#analytics_fill_profile').val());
    advertiser_analytics_profile_change(selects['profile'], true);
     selects['profile'].trigger('change.select2');

    //  console.log('start analytics_fill_property', $('#analytics_fill_property').val());
    //
    //  selects['property'].val($('#analytics_fill_property').val());
    // console.log('start analytics_fill_property selects', selects['property']);
    //  advertiser_analytics_property_change(selects['property']);
    //  selects['property'].trigger('change.select2');
    //
    //  selects['view'].val($('#analytics_fill_view').val());
    //  advertiser_analytics_view_change(selects['view']);
    //  selects['view'].trigger('change.select2');
};

var advertiser_analytics_fill_centro = function () {
    selects_centro['account'].val($('#analytics_fill_account_centro').val());
    advertiser_analytics_account_change_centro(selects_centro['account']);
    selects_centro['account'].trigger('change.select2');
    selects_centro['brand'].val($('#analytics_fill_brand_centro').val());
    advertiser_analytics_profile_change_centro(selects_centro['brand']);
    selects_centro['brand'].trigger('change.select2');
    selects_centro['campaign'].val($('#analytics_fill_campaign_centro').val());
    advertiser_analytics_view_change_centro(selects_centro['campaign']);
    selects_centro['campaign'].trigger('change.select2');
};

var advertiser_analytics_fill_quickbooks = function () {
    selects_quickbooks['account'].val($('#quickbooks_fill_account').val());
    advertiser_quickbooks_view_change(selects_quickbooks);
    selects_quickbooks['account'].trigger('change.select2');
};

var vendor_analytics_fill_quickbooks = function () {
    selects_quickbooks['account'].val($('#quickbooks_fill_account').val());
    vendor_quickbooks_view_change(selects_quickbooks);
    selects_quickbooks['account'].trigger('change.select2');
};
